angular.module('data.rate-change', []);
